import { Component, Input, OnInit } from "@angular/core";

import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AdmakerService } from "../admaker.service";
import { isEmpty } from "rxjs-compat/operator/isEmpty";

@Component({
  selector: "app-admaker-tool",
  templateUrl: "./admaker-tool.component.html",
  styleUrls: ["./admaker-tool.component.css"],
})
export class AdmakerToolComponent implements OnInit {

   
  @Input() setting;
  // @Input() themeType;
  theme;
  themes: string[] = [
    "make, model, transmission",
    "make, model, bodyType",
    "make, model, variant",
    "make, model, fuelType",
  ];
  orders: Number[] = [];
  GetItems = [];
  droppes: any[] = [];
  limit: number = 0;
  name: string = "";
  progress = 0;
  percentSign = "%";
  color = "black";
  isHidden = true;
  blinking = false;
  inlistVal;
  inlistValLength;
  order = 5;
  @Input() currentOrder: Number;
  @Input() myAd: any;
  seedAd = '';
  @Input() nowTheme;
  @Input() isnew;
  @Input() client;
  @Input() adConfid;
  @Input() adConftempid;
  orderGenerator() {
    for (let index = 1; index <= this.order; index++) {
      this.orders.push(index);
    }
  }
  blinker() {
    if (this.blinking === false) {
      this.blinking = true;
    }
    setTimeout(() => {
      this.blinking = false;
    }, 2000);
    return this.blinking;
  }
  DataShow() {
    if (this.droppes.length > 0) {
      this.isHidden = false;
    } else {
      this.isHidden = true;
    }
    return this.isHidden;
  }
  getColor() {
    if (this.progress == 100) {
      this.color = "red";
    } else {
      this.color = "green";
    }
    return this.color;
  }
  @Input() Allelements:any[]=[];
  elements: any[] = [];
  phrases: any[] = [];
  valueChooser(name: string) {
    let n = name.toLowerCase();
    let value = 'None';
    switch (n) {
      case 'make':
        value="Ford"
        break;
      case 'model':
        value = "Ecosport"
        break;
      case 'colour':
        value = "Red"
        break;
      case 'fueltype':
        value = "Petrol"
        break;
      case 'doors':
        value = "4 Doors"
        break;
      case 'year':
        value = "2019"
        break;
      case 'bodytype':
        value = "SUV"
        break;
      case 'enginesize':
        value = "Ecosport"
        break;
      case 'milege':
        value = "6mi/L"
        break;
      case 'variant':
        value = "Titanium"
        break;
      case 'transmission':
        value = "manual"
        break;
      case 'displayname':
        value = "displayName"
        break;
      case 'displaylocation':
        value = "displayLocation"
        break;
      case 'seed':
        value = "Seed"
        break;
      case 'price':
        value = "£"
        break;
      default:
        value = 'None';
        break;
    }
    return value;

  }
  constructor(private _snackBar: MatSnackBar, private adms: AdmakerService) {
    this.elements = [];
    this.phrases = [
      { name: "Miles", type: "button", etype: 'phrase', inList: false, inListValue: "30Miles",isspace:true },
      { name: "Smart", type: "button", etype: 'phrase', inList: false, inListValue: "Smart", isspace: true },
      {
        name: "Saving",
        type: "button",
        inList: false,
        inListValue: "$200 Saving",
        etype: 'phrase', isspace: true
      },
      {
        name: "Owners",
        type: "button",
        inList: false,
        inListValue: "First Hand",
        etype: 'phrase', isspace: true
      },
      { name: "MPG", type: "button", inList: false, inListValue: "Mpg", etype: 'phrase', isspace: true },
      {
        name: "Smart Count",
        type: "button",
        inList: false,
        inListValue: "Smart Count", etype: 'phrase', isspace: true
      },
      { name: "Only", type: "text", inList: false, inListValue: "Only", etype: 'phrase', isspace: true },
      { name: "at", type: "text", inList: false, inListValue: "at", etype: 'phrase', isspace: true },
      { name: "with", type: "text", inList: false, inListValue: "with", etype: 'phrase', isspace: true},
      { name: "in", type: "text", inList: false, inListValue: "in", etype: 'phrase', isspace: true },
    ];
  }
  progress_cal() {
    this.progress = (this.result_str.length * 100) / this.limit;
    this.progress = Math.floor(this.progress);
    return this.progress;
  }
  get_length_head() {
    return this.result_str.length;
  }

  transTxtElem(e) {
    let price_obj = { name: "£", type: "text", inList: false, inListValue: "£", etype: 'phrase', isspace: true };
    console.log(e)
    if (this.result_str.length + e.inListValue.length < this.limit) {
      if (this.get_length_head() == this.limit) {
        this._snackBar.open("You are reached to limit to drop list", "Undo", {
          duration: 3000,
        });
      } else if (this.get_length_head() < this.limit) {
        if (e.code == '<price>') {
          this.droppes.push(price_obj);

        }
        e.inList = true;
        this.droppes.push(e);
        console.log(e);
        this._snackBar.open(e.name + " Added to drop list", "Undo", {
          duration: 3000,
        });
        const indexTxt = this.phrases.indexOf(e, 0);
        this.phrases.splice(indexTxt, 1);
        this.dbsTrMaker();
        this.progress_cal();
        this.blinker();
        this.seedAdMaker();

      }
    } else {
      this._snackBar.open("No Capacity drop list");
    }
  }

  transBtnElem(e) {
    let price_obj = { name: "£", type: "text", inList: false, inListValue: "£", etype: 'phrase', isspace: true };
    console.log(e)
    if (this.result_str.length + e.inListValue.length < this.limit) {
      if (this.result_str.length == this.limit) {
        this._snackBar.open("You are reached to limit to drop list", "Undo", {
          duration: 3000,
        });
      } else if (this.get_length_head() < 100) {
        if (e.code == '<price>') {
          this.droppes.push(price_obj);

        }
        e.inList = true;
        this.droppes.push(e);
        this._snackBar.open(e.name + " Added to drop list");
        const indexBtn = this.elements.indexOf(e, 0);
        this.elements.splice(indexBtn, 1);
        this.dbsTrMaker();
        this.progress_cal();
        this.blinker();
        this.seedAdMaker();
      }
    } else {
      this._snackBar.open("No Capacity drop list", "Undo", {
        duration: 3000,
      });
    }
  }
  drop(event: CdkDragDrop<string[]>) {
    console.log(event);
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      let Arrays = event.container.data[event.currentIndex];
      this.listMakerBydrag(Arrays, event.currentIndex);
    } else {
      if (event.container.id != "result_drop") {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
        let Array: any = event.container.data[event.currentIndex];
        Array["inList"] = false;
        this.listMakerBydrag(Array, event.currentIndex, true, event.previousIndex);
        return 1;
      }
      if (this.get_length_head() == this.limit) {
        if (event.container.id != "result_drop") {
          console.log("cs");
          let Array: any = event.container.data[event.currentIndex];
          Array.inList = false;
          transferArrayItem(
            event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            event.currentIndex
          );
          this.listMakerBydrag(Array, event.currentIndex);
        }
        this._snackBar.open("You are reached to limit to drop list", "Undo", {
          duration: 3000,
        });
        console.log(event);
      } else if (this.get_length_head() < this.limit) {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );

        this.inlistVal =
          event.container.data[event.currentIndex]["inListValue"];
        this.inlistValLength = parseInt(this.inlistVal.length);
        if (this.result_str.length + this.inlistValLength + 1 <= this.limit) {
          this.blinker();
          let name = event.container.data[event.currentIndex]["name"];
          this._snackBar.open(name + " Added to drop list", "Undo", {
            duration: 3000,
          });

          let Array = event.container.data[event.currentIndex];
          if (event.container.id === "result_drop") {
            Array["inList"] = true;
           
            this.listMakerBydrag(Array, event.currentIndex,true);
            if (this.progress == 100) {
              this._snackBar.open(
                "You are reached to limit to drop list",
                "Undo",
                {
                  duration: 3000,
                }
              );
            }
          }
        } else {
          transferArrayItem(
            event.container.data,
            event.previousContainer.data,
            event.currentIndex,
            event.previousIndex
          );
        }
        if (event.container.id !== "result_drop") {
          let Array = event.container.data[event.currentIndex];
          Array["inList"] = false;
          this.listMakerBydrag(Array, event.currentIndex);
        }
      }
    }
  }

  db_setting_str = "";
  result_str = "";
  // listMaker(arr) {
  //   if (arr.inList === true) {
  //     // console.log(arr);
  //     this.db_setting_str += " " + arr.inListValue;
  //     this.result_str = this.db_setting_str.trim();
  //   }

  // }
  listMakerTwo(arr) {
    let selected = JSON.parse(localStorage.getItem("selected")) || "";
    let selectedCopy = JSON.parse(localStorage.getItem("allTheme"))[selected];
    let allTheme = JSON.parse(localStorage.getItem("allTheme"));

      console.log(this.droppes);
      if (selectedCopy) {
        if (selectedCopy[this.currentOrder.toString()]) {
          selectedCopy[this.currentOrder.toString()]["config"] = this.droppes;
        } else {
          // selectedCopy = {};
          selectedCopy[this.currentOrder.toString()] = {};
          selectedCopy[this.currentOrder.toString()]["theme"] = "";

          selectedCopy[this.currentOrder.toString()]["config"] = this.droppes;
        }
      } else {
        selectedCopy = {};
        selectedCopy[this.currentOrder.toString()] = {};
        selectedCopy[this.currentOrder.toString()]["theme"] = "";

        selectedCopy[this.currentOrder.toString()]["config"] = this.droppes;
      }
      // selectedCopy[this..toString()]["config"] = this.droppes;
      // this.allTheme[selected]["config"] = this.droppes;
      allTheme[selected] = selectedCopy;

    this.dbsTrMaker();
      localStorage.setItem("allTheme", JSON.stringify(allTheme));

      //this.progress_cal();
    // this.db_setting_str = "";
    // this.droppes.forEach((s) => {
    //   this.db_setting_str += " " + s.inListValue;
    //   this.result_str = this.db_setting_str.trim();
    // });
  }



  listMakerBydrag(arr, ind, differentbox = false, prevInd = NaN) {
    let price_obj = { name: "£", type: "text", inList: false, inListValue: "£", etype: 'phrase', isspace: true };
    if (arr['code'] == "<price>" && arr['inList'] == true && differentbox) {

      for (let s = this.droppes.length; ind < s; s--) {
        this.droppes[s] = this.droppes[s - 1];
      }
      this.droppes[ind] = price_obj
    } else if(arr['code'] == "<price>" && arr['inList'] == false) {

      let prevobj = this.droppes[prevInd - 1];
      if (prevobj) {
        let inlistvalprev: string = this.droppes[prevInd - 1]['inListValue'].trim();
        let arrins = inlistvalprev.split(" ");
        //console.log(arrins)

        if (inlistvalprev == "£") {
          this.droppes.splice(prevInd - 1, 1);
        } else if (arrins[arrins.length - 1].includes('£')) {
          
          if (arrins[arrins.length - 1] == "£") {
            arrins.splice(arrins.length - 1, 1);
          } else {
            console.log("Mooo")
            let rst = arrins[arrins.length - 1].split('').reverse().join('');
            
            rst=rst.replace('£', '');
            let st = rst.split('').reverse().join('');
            arrins[arrins.length - 1] = st;
           
          }
          inlistvalprev = arrins.join();
          this.droppes[prevInd - 1]['inListValue'] = inlistvalprev;
        }
      }

    }



    //else {
    this.dbsTrMaker()
      this.seedAdMaker();

    //}

  }

  getLast_droppes() {
    if (this.droppes.length > 0) {
      return this.droppes[this.droppes.length - 1];
    }
  }


   

  saveStr() {
    
    let selected = JSON.parse(localStorage.getItem("selected")) || "";
    let adPartId = JSON.parse(localStorage.getItem("adPart_id")) || "";
    let obj = {
      AdPartId: adPartId,
      SeedText: this.seedAd,
      AdThemeId: this.nowTheme,
      AdOrder: this.currentOrder,
      tempid: this.adConftempid,
      ClientID: this.client,
      Id: this.isnew ? 0 : this.adConfid
    }


    if (!obj.SeedText) {

      alert("New seedText Should not be empty");
      return;
    }
    else if (!obj.AdOrder || obj.AdOrder === null) {

      alert("Order Number Should not be empty");
      return;

    }

    
    this.adms.saveAd(obj).subscribe((res: any) => {
      if (res) {
        obj['id'] = res['id'];
      }
      console.log(obj)

      this.adms.savelocal.emit(obj);
      this.savedOrder = obj.AdOrder;
      this.isnew = false;
      this._snackBar.open(
        this.name + " AdConfig Saved",
        "Ok",
        {
          duration: 3000,
        }
      );
    }, (err) => {
      this._snackBar.open(
        this.name + " AdConfig Not Saved , Something went wrong",
        "Ok",
        {
          duration: 3000,
        }
      );
    })

    

    
  
  }
  removeStr() {
    localStorage.removeItem(this.name);
    this._snackBar.open("Settings are removed from localsession", "Undo", {
      duration: 3000,
    });

    this.droppes = [];
    this.db_setting_str = "";
    this.result_str = "";
    this.elements = [
      { name: "make", type: "button", inList: false, inListValue: "Ford" },
      { name: "model", type: "button", inList: false, inListValue: "Ecosport" },
      { name: "color", type: "button", inList: false, inListValue: "Red" },
      {
        name: "fuelType",
        type: "button",
        inList: false,
        inListValue: "Petrol",
      },
      { name: "doors", type: "button", inList: false, inListValue: "4 Doors" },
      { name: "year", type: "button", inList: false, inListValue: "2019" },
      { name: "bodyType", type: "button", inList: false, inListValue: "SUV" },
      {
        name: "engineSize",
        type: "button",
        inList: false,
        inListValue: "2.0L",
      },
      { name: "Milege", type: "button", inList: false, inListValue: "6mi/L" },
      {
        name: "variant",
        type: "button",
        inList: false,
        inListValue: "Titanium",
      },
    ];
    this.phrases = [
      { name: "Miles", type: "button", inList: false, inListValue: "30Miles" },
      { name: "Smart", type: "button", inList: false, inListValue: "Smart" },
      {
        name: "Saving",
        type: "button",
        inList: false,
        inListValue: "$200 Saving",
      },
      {
        name: "Owners",
        type: "button",
        inList: false,
        inListValue: "First Hand",
      },
      { name: "MPG", type: "button", inList: false, inListValue: "Mpg" },
      {
        name: "Smart Count",
        type: "button",
        inList: false,
        inListValue: "Smart Count",
      },
      { name: "Only", type: "text", inList: false, inListValue: "Only" },
      { name: "at", type: "text", inList: false, inListValue: "at" },
      { name: "with", type: "text", inList: false, inListValue: "with" },
      { name: "in", type: "text", inList: false, inListValue: "in" },
    ];
    this.progress = 0;
  }
  switchTheme(val) {
    this.theme = val["theme"] || "";

    // this.setTheme(this.theme);
  }
  setTheme(theme) {
    let selected = JSON.parse(localStorage.getItem("selected")) || "";
console.log(this.theme)
    console.log(selected)


    if (selected == this.name) {
      let themeArr = this.theme.split(",");
      let newArr = [];
      themeArr.forEach((element) => {
        let elem = element.trim();
        this.Allelements.forEach((e) => {
          if (e.name.toLowerCase() == elem.toLowerCase()) {
            newArr.push(e);
          }
        });
      });

      this.droppes = newArr;


      this.elem_phrase_clear();
      this.dbsTrMaker()

      console.log(this.result_str);
    }
  }

  elem_phrase_clear() {
    this.elements = [...this.Allelements];
    this.droppes.forEach((dr) => {
      this.elements.forEach((e, i) => {
        if (dr.name.toLowerCase() == e.name.toLowerCase()) {
          this.elements.splice(i, 1);
        }
      });
      this.phrases.forEach((e, i) => {
        if (dr.name.toLowerCase() == e.name.toLowerCase()) {
          this.phrases.splice(i, 1);
        }
      });
    });
    // console.log(this.elements);
  }
  allTheme = JSON.parse(localStorage.getItem("allTheme")) || {};

  savedOrder:Number;
  ngOnInit(): void {
    this.limit = this.setting.limit;
    this.name = this.setting.name;
    this.savedOrder = this.currentOrder;
    this.getAdfields();



    this.adms.changeStepper.subscribe((res) => {
      let selected = JSON.parse(localStorage.getItem("selected"));

      this.dbsTrMaker()

      this.elem_phrase_clear();
    });

    //let selected = JSON.parse(localStorage.getItem("selected"));
    //let selectedTheme =
    //  JSON.parse(localStorage.getItem("allTheme"))[selected] || "";
    //if (selectedTheme[this.currentOrder.toString()]) {
    //  this.droppes =
    //    selectedTheme[this.currentOrder.toString()]["config"] || [];
    //} else {
    //  this.droppes = [];
    //}
    //this.db_setting_str = "";

    //this.droppes.forEach((s) => {
    //  this.db_setting_str += " " + s.inListValue;
    //  this.result_str = this.db_setting_str.trim();
    //});
    //this.progress_cal();
    //this.elem_phrase_clear();

    // this.switchTheme(selectedTheme)
  }



  sdrop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }
  

  getAdfields() {
    //this.adms.getAdCFields().subscribe((r: any) => {
    //  let fields: any[] = r['adFields'];
    //  fields.map((e: any) => {
    //    e.type = 'button';
    //    e.etype = 'elements';
    //    e.inList = false;
    //    e.inListValue = this.valueChooser(e.name),
    //      e.isspace = e.name.toLowerCase()=='price'?true:true
    //  })
    //  this.Allelements = fields;
      

    //})
    if (this.Allelements.length > 0) {
      this.elements = [...this.Allelements];
      console.log(this.elements)
      this.elem_phrase_clear();
      this.seedToDropes();
    } 
  }

  











  seedToDropes() {
    //let str = 'Why not test drive this <year> <colour> <make> <model> with <mileage> miles. Now Only £<price>';
    //let str = 'Contact <displayName> of <displayLocation>';
    //let str = '<engineSize> <fuelType> With <mileage> Miles';
    //let str = '<make> <model>';
    let str = this.myAd;

    let arrstrr = str.split(' ');


    let ne = [];
    arrstrr.forEach((a) => {
      if (a.includes('<') && a.includes('>') && (a.charAt(0) !== '<' || a.charAt(a.length - 1) !== '>')) {
        let rev; let result;
        if (a.charAt(0) !== '<') {
          rev = a.split("").reverse().join("");
          result = a.substr(-(rev.indexOf('<') + 1), a.length);
          ne.push(a.substr(0, a.indexOf('<')))
          //console.log(result)

        } else if (a.charAt(a.length - 1) !== '>') {
          rev = a.split("").reverse().join("");

          result = a.substr(0, a.indexOf('>') + 1);
          //console.log(result)
          ne.push(a.substr(-(rev.indexOf('>')), a.length));

        }
        ne.push(result);



      } else {
        ne.push(a);
      }
    })

    let elements = this.Allelements;
    let droppes = [];
    ne.forEach((n) => {
      if (n.includes('<') && n.includes('>')) {
        let inOfel = elements.find((s) => { return s.code == n });
        if (inOfel) {
          droppes.push(inOfel);
        } else {
          droppes.push(n);
        }
      } else {
        droppes.push(n);
      }
    })
    let finalDropes = [];
    let st = "";
    droppes.forEach((sx, insx) => {
      let nxtelemObj = "";
      if (typeof (droppes[insx + 1]) == 'string') {
        nxtelemObj = " ";
      } else {
        nxtelemObj = "";
      }
      if (typeof (sx) == 'string') {
        st = st + sx + nxtelemObj;
        if ((insx + 1) == droppes.length) {
          let stob = { name: st, type: "text", inList: true, inListValue: st, etype: 'phrase' }
          finalDropes.push(stob);
        }
      } else {
        if (st) {
          let stob = { name: st, type: "text", inList: true, inListValue: st, etype: 'phrase' }
          finalDropes.push(stob);
          st = "";
        }
        finalDropes.push(sx);
      }

    })
    this.droppes = finalDropes;
    this.dbsTrMaker();
    this.seedAdMaker(false);
  }


  dbsTrMaker() {
    this.elem_phrase_clear();
    this.db_setting_str = "";
    let sp = " ";
    let wantSpace = true;

    this.droppes.forEach((s) => {
      if (!wantSpace) {
        sp = "";
        wantSpace = true;
      } else {
        sp=" "
      }
      this.db_setting_str += sp + s.inListValue;
      this.result_str = this.db_setting_str.trim();
      if (s.isspace == false) {
        wantSpace = false;
      }
    });
    this.progress_cal();
  }

  seedAdMaker(drag=true) {
    let sp = " ";
    let wantSpace = true;
    this.seedAd = "";
    this.droppes.forEach((s) => {
      if (!wantSpace) {
        sp = "";
        wantSpace = true;
      } else {
        sp = " "
      }
      if (s.etype == 'elements') {
        let code = "";
        if (drag) {
          code = s.code == '<price>' ? '<price>' : s.code;

        } else {
          code = s.code == '<price>' ? '<price>' : s.code;

        }
        this.seedAd += sp + code;
      } else {
        this.seedAd += sp + s.inListValue;
      }
      this.seedAd = this.seedAd.trim();
      if (s.isspace == false) {
        wantSpace = false;
      }
    });
    this.seedAd = this.seedAd.replace("£ <price>", "£<price>");
  }


  admakerAndSeedMAker() {
    this.dbsTrMaker();
    this.seedAdMaker();
  }

  visible: boolean = false
  isEnabled:boolean=false
  
  onkeypress(event)
  {
    
      this.visible = !this.visible;
    
    
    var dis = document.getElementById("Orderno");

    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      //this.isEnabled = true;
      

      return false;
      
      
    } else {
      return true;
    }
    
   
 
    
  }

  deleteConf() {
    let adPartId = JSON.parse(localStorage.getItem("adPart_id")) || "";
    let data = {
      AdPartId: adPartId,
      AdThemeId: this.nowTheme,
      AdOrder: this.currentOrder,
      ClientID: this.client,
      tempid: this.adConftempid,
    }
    this.adms.delAdconfig.emit(data);
  }

  deleteConfDb(id) {
    if (!this.isnew && this.client) {
      this.adms.delAdConfigs(id).subscribe((r) => {
        this.deleteConf();
        this._snackBar.open(
          "AdConfig deleted",
          "Ok",
          {
            duration: 3000,
          }
        );
      }, (e) => { })
    } else {
      this._snackBar.open(
        "This adconfig is not allowed to delete",
        "Ok",
        {
          duration: 3000,
        }
      );
    }
  }



  showAdhere(comp:string) {
    
    let selected: string = JSON.parse(localStorage.getItem("selected")) || "";
    if (selected) {
      selected = selected.toLowerCase();
    }
    if (selected.includes(comp.toLowerCase())){
      return this.result_str;
    }
    return null;
  }

}
